import React from 'react';
import { XIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { painPoints } from '../data/content';
export function PainSection() {
  return <section className="border-b border-line bg-cream" data-id="element-177" data-mp="38vkeocenfju7">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-178" data-mp="2uxdrbq7bt28s">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-179" data-mp="2yz7ovpm85q4q">
          <div data-id="element-180" data-mp="2z1lf9l5yme5y">
            <Eyebrow data-id="element-181" data-mp="2l8m39t5dz235">La realidad de enseñar música</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-182" data-mp="2l719i5qwbn6c">
              ¿Te suena familiar?
            </h2>
            <p className="mt-5 font-display text-xl italic leading-snug text-accent" data-id="element-183" data-mp="2baxxm868sa67">
              ¿Cuánto tiempo más vas a seguir improvisando cada clase?
            </p>
            <p className="mt-5 max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-184" data-mp="229i0310j02je">
              Lo entendemos. Tu tiempo debería estar puesto en enseñar y cambiar vidas — no atrás
              de una pantalla maquetando fichas.
            </p>
          </div>

          <ul className="divide-y divide-line border-y border-line" data-id="element-185" data-mp="3rl7n04hj27yn">
            {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-4" data-id="element-186" data-mp="3nnicmz3fx193">
                <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-soft text-accent" data-id="element-187" data-mp="5faoxbz9hqyh">
                  <XIcon className="h-3.5 w-3.5" data-id="element-188" data-mp="38x2pvfvdll8t" />
                </span>
                <p className="text-[15px] leading-relaxed text-ink" data-id="element-189" data-mp="33yhm56gx0jfm">{point}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}